import * as React from "react";
import { IconProps } from "./IconProps";

export const IconEditSolid = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <g id="edit">
          <g id="Union">
            <path
              d="M11.49 2.51015C10.9433 1.96341 10.0569 1.96341 9.51016 2.51015L9.14074 2.87956C9.03823 2.98207 9.03823 3.14828 9.14074 3.25079L10.7494 4.85946C10.8519 4.96197 11.0181 4.96197 11.1206 4.85946L11.49 4.49004C12.0368 3.94331 12.0368 3.05688 11.49 2.51015Z"
              fill={color}
            />
            <path
              d="M7.77957 4.24073C7.88208 4.13821 8.04829 4.13821 8.1508 4.24073L9.75945 5.84939C9.86197 5.95191 9.86197 6.11811 9.75945 6.22062L4.15688 11.8232C4.10765 11.8724 4.04088 11.9001 3.97126 11.9001H2.3626C2.21762 11.9001 2.1001 11.7826 2.1001 11.6376V10.0289C2.1001 9.95932 2.12775 9.89255 2.17698 9.84332L7.77957 4.24073Z"
              fill={color}
            />
          </g>
        </g>
      </svg>
    );
  },
);
